
import msDataProvider from "../../services/msDataProvider";
import uiService from "../../services/uiService";
import ratingService from "@/services/ratingService";

export default {
  data() {
    return {
      currentTabSelected: "",
      appRefreshing: false,
      version: "",
      updateStatus: null,
      binding: {},
      activeTab: 0,
      tabs: [
        {
          path: 'connection',
          icon: 'vcs-icon-connection',
          name: this.$t('LAYOUT.CONNECTION'),
        },
        {
          path: 'options',
          icon: 'vcs-icon-three-line',
          name: this.$t('LAYOUT.OPTIONS'),
        },
      ],
      isShowDeviceTab: true
    };
  },
  methods: {
    goTo(path: string, tabIndex, activeTab) {
      if (tabIndex === activeTab) {
        return;
      }
      this.$router.push({name: path, query: (this.isShowDeviceTab === false && tabIndex === 1) ? {hideDeviceOpt: "true"} : null})
    },
    async initializeRating() {
      let updateStatus;
      for (let i = 0; i < 100; i++) {
        updateStatus = await msDataProvider.executeCommand("updateGetStatus");
        if (updateStatus && updateStatus.version) {
          break;
        }
        await new Promise((resolve) => setTimeout(resolve, 500));
      }
      this.updateStatus = updateStatus;
      for (let i = 0; i < 100; i++) {
        if (this.binding.authenAuthenInfo && this.binding.authenAuthenInfo.user_info.user_id) {
          break;
        }
        await new Promise((resolve) => setTimeout(resolve, 500));
      }
      setTimeout(async () => {
        await ratingService.init(this.updateStatus.version, this.binding.authenAuthenInfo.user_info.user_id);
        await ratingService.sessionUpdate();
      }, 500);
      setTimeout(async () => {
        if (await ratingService.isOpenRatingDialog({
          version: this.updateStatus.version,
          userId: this.binding.authenAuthenInfo.user_info.user_id
        })) {
          await uiService.executeCommand('ratingDialogShow');
        }
      }, 2000)
    },
    async checkDeviceOption() {
      try {
        await msDataProvider.executeCommand('deviceLoginSessionGetAllByUser');
        this.isShowDeviceTab = true;
      } catch(e: any) {
        if (e.message &&  e.message.includes('Error: Not Found')) {
          this.isShowDeviceTab = false;
        }
      }
    },
  },
  async created() {
    await msDataProvider.bindDataMany(
        [
          "authenAuthenInfo",
        ],
        this.binding,
        this,
        null,
        this
    );
    sessionStorage.removeItem("biometricData")
    await this.initializeRating();
    await this.checkDeviceOption();
  },

  watch: {
    $route(to) {
      if (to && to.fullPath && to.fullPath.includes("connection") && this.activeTab !== 0) {
        this.activeTab = 0;
        return;
      }
      if (to && to.fullPath && !this.tabs.find(tab => to.fullPath.includes(tab.path))) {
        this.activeTab = 0;
      }
    },
  },

  beforeRouteLeave(to, from, next) {
    msDataProvider.unregisterView(this);
    next();
  },
};
